import { render, staticRenderFns } from "./FooterMob.vue?vue&type=template&id=2d72cffa&scoped=true"
import script from "./FooterMob.vue?vue&type=script&lang=js"
export * from "./FooterMob.vue?vue&type=script&lang=js"
import style0 from "./FooterMob.vue?vue&type=style&index=0&id=2d72cffa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@corefy+vue2-vue-template-compiler@2.7.24_@vue+compiler-sfc@3.5.17_b_3cd151110130808e214f6f819bd7543a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d72cffa",
  null
  
)

export default component.exports